/* GLŌEWE — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ── PANEL NAV active state ── */
  var path = window.location.pathname;
  document.querySelectorAll('.panel-nav__item').forEach(function (el) {
    var href = el.getAttribute('href') || '';
    if (href && path.startsWith(href) && href !== '/') {
      el.classList.add('is-active');
    } else if (href === '/' && path === '/') {
      el.classList.add('is-active');
    }
  });

  /* ── MOBILE NAV TOGGLE ── */
  var navToggle = document.querySelector('.landing-nav__menu-toggle');
  var navDrawer = document.querySelector('.landing-nav__drawer');
  if (navToggle && navDrawer) {
    var setNavOpen = function (open) {
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      navDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      navDrawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    navToggle.addEventListener('click', function () {
      setNavOpen(navToggle.getAttribute('aria-expanded') !== 'true');
    });
    navDrawer.addEventListener('click', function (e) {
      if (e.target.matches('a')) setNavOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setNavOpen(false);
    });
  }

  /* ── ACCORDION ── */
  document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion__item');
      item.classList.toggle('is-open');
    });
  });

  /* ── VARIANT SELECTOR ── */
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.variant-selector__options');
      group.querySelectorAll('.variant-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      updatePrice(btn);
    });
  });

  function updatePrice(btn) {
    var price = btn.dataset.price;
    var priceEl = document.querySelector('.product-price');
    if (price && priceEl) {
      priceEl.textContent = formatMoney(parseInt(price, 10));
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace('.00', '');
  }

  /* ── ADD TO BAG ── */
  var atbForm = document.querySelector('.product-form');
  if (atbForm) {
    atbForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = atbForm.querySelector('.btn-atb');
      var variantInput = atbForm.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        updateCartCount();
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add to bag';
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to bag';
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        });
      });
  }

  /* ── WAITLIST FORM ── */
  document.querySelectorAll('.js-waitlist-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn   = form.querySelector('button[type="submit"]');
      if (!input || !input.value) return;
      btn.disabled = true;
      btn.textContent = 'Done';
      input.value = '';
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || '→ Join';
      }, 3000);
    });
  });

  /* ── PRODUCT GALLERY THUMBS ── */
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.src;
      var main = document.querySelector('.product-gallery__main img');
      if (src && main) {
        main.src = src;
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      }
    });
  });

  /* ── SMOOTH SCROLL for landing vignettes ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

});